import { useRegistrationGiftIndicators } from "@configs/statsig";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import { GiftBoxIcon } from "../GiftBoxIcon";

interface FreeGiftsBadgeProps extends PropsWithClassName {
  visible?: boolean;
}

const FreeGiftsBadge = ({ className, visible = true }: FreeGiftsBadgeProps) => {
  const { t } = useTranslation();
  const { showFreeGiftsBadge } = useRegistrationGiftIndicators();

  if (!visible || !showFreeGiftsBadge) return null;

  return (
    <div
      className={cn("absolute left-1/2 -translate-x-1/2", "animate-fade-in", className)}
      aria-label="Free gift badge"
    >
      <div
        className={cn("flex items-center gap-1", "px-2 py-0.5", "shadow-lg", "whitespace-nowrap", "h-5", "rounded-xl")}
        style={{
          background: "linear-gradient(180deg, #B91C1C -15%, #4B0505 220%)",
        }}
      >
        <GiftBoxIcon
          width={16}
          height={16}
          animated={false}
          className="animate-none"
        />
        <span className="text-[10px] font-bold text-[#F8CC8B]">{t("free gift")}</span>
      </div>

      <div className="absolute left-4 top-full -mt-px">
        <div
          className="h-2 w-3 bg-[#851111]"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 100%)",
          }}
        />
      </div>
    </div>
  );
};

export default FreeGiftsBadge;
